import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { useAddressLabel } from '../../../hooks/use-address-label';
import { AddressInputWUT } from '../../../ui/address-input';
import { TextInputFieldWUT } from '../../../ui/text-input-field';
import { useAddressAutofill } from '../../multiline-address/multiline-address/address-autofill-context';
export const MlaAddressLineWUT = _ref => {
  let {
    autocomplete,
    ...rest
  } = _ref;
  const fieldType = FIELD_TYPES.MLA_ADDRESS_LINE;
  const {
    autocompleteEnabled
  } = useAddressAutofill();
  const label = useAddressLabel('addressLine1');
  return autocomplete || autocompleteEnabled ? /*#__PURE__*/React.createElement(AddressInputWUT, _extends({}, rest, {
    fieldType: fieldType,
    label: label
  })) : /*#__PURE__*/React.createElement(TextInputFieldWUT, _extends({}, rest, {
    fieldType: fieldType,
    label: label
  }));
};
//# sourceMappingURL=mla-address-line-wut.js.map